import { render } from "./Facebook.vue?vue&type=template&id=2db45fd6"
const script = {}

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__